@for (filter of filters; track filter) {
  <sd-store-filter
    (filterChange)="onFilterChange()"
    [brand]="brand"
    [filter]="filter"
  />
}
